import { SUPPORTED_LOCALES, DEFAULT_LOCALE, isSupportedLocale } from 'anchor-i18n';
export { SUPPORTED_LOCALES, DEFAULT_LOCALE, isSupportedLocale };
export const LOCALE_LABELS = {
    en: 'English',
    es: 'Español'
};
export const LOCALE_COOKIE_NAME = 'anchor_locale';
export const LOCALE_PREFERENCE_KEY = 'anchor.native.locale.v1';
export const LOCALE_COOKIE_EXPIRY = new Date('2099-12-31');
export function readLocaleCookie(cookieString) {
    var _match_split_;
    const match = cookieString.split(';').find((c)=>c.trim().startsWith("".concat(LOCALE_COOKIE_NAME, "=")));
    if (!match) {
        return DEFAULT_LOCALE;
    }
    const value = (_match_split_ = match.split('=')[1]) === null || _match_split_ === void 0 ? void 0 : _match_split_.trim();
    return isSupportedLocale(value) ? value : DEFAULT_LOCALE;
}
